<template>
    <Layout>
        <section class="section">
            <div class="container">
                <h2>Photo Gallery</h2>
                <div class="row popup-gallery">
                    <div class="popup-gallery__item col-xs-6 col-md-4">
                        <a href="assets/img/gallery/efg-1x1-18-1.jpg"><img src="assets/img/gallery/thumbs/efg-1x1-18-1.jpg"></a>
                    </div>


                    <div class="popup-gallery__item col-xs-6 col-md-4">
                        <a href="assets/img/gallery/efg-1x1-18-2.jpg"><img src="assets/img/gallery/thumbs/efg-1x1-18-2.jpg"></a>
                    </div>


                    <div class="popup-gallery__item col-xs-6 col-md-4">
                        <a href="assets/img/gallery/efg-1x1-18-3.jpg"><img src="assets/img/gallery/thumbs/efg-1x1-18-3.jpg"></a>
                    </div>


                    <div class="popup-gallery__item col-xs-6 col-md-4">
                        <a href="assets/img/gallery/efg-1x1-18-4.jpg"><img src="assets/img/gallery/thumbs/efg-1x1-18-4.jpg"></a>
                    </div>


                    <div class="popup-gallery__item col-xs-6 col-md-4">
                        <a href="assets/img/gallery/efg-1x1-18-5.jpg"><img src="assets/img/gallery/thumbs/efg-1x1-18-5.jpg"></a>
                    </div>


                    <div class="popup-gallery__item col-xs-6 col-md-4">
                        <a href="assets/img/gallery/efg-1x1-18-6.jpg"><img src="assets/img/gallery/thumbs/efg-1x1-18-6.jpg"></a>
                    </div>


                    <div class="popup-gallery__item col-xs-6 col-md-4">
                        <a href="assets/img/gallery/efg-1x1-18-7.jpg"><img src="assets/img/gallery/thumbs/efg-1x1-18-7.jpg"></a>
                    </div>


                    <div class="popup-gallery__item col-xs-6 col-md-4">
                        <a href="assets/img/gallery/efg-1x1-18-8.jpg"><img src="assets/img/gallery/thumbs/efg-1x1-18-8.jpg"></a>
                    </div>


                    <div class="popup-gallery__item col-xs-6 col-md-4">
                        <a href="assets/img/gallery/efg-1x1-18-9.jpg"><img src="assets/img/gallery/thumbs/efg-1x1-18-9.jpg"></a>
                    </div>


                    <div class="popup-gallery__item col-xs-6 col-md-4">
                        <a href="assets/img/gallery/efg-1x1-18-10.jpg"><img src="assets/img/gallery/thumbs/efg-1x1-18-10.jpg"></a>
                    </div>


                    <div class="popup-gallery__item col-xs-6 col-md-4">
                        <a href="assets/img/gallery/efg-1x1-18-11.jpg"><img src="assets/img/gallery/thumbs/efg-1x1-18-11.jpg"></a>
                    </div>


                    <div class="popup-gallery__item col-xs-6 col-md-4">
                        <a href="assets/img/gallery/efg-1x1-18-12.jpg"><img src="assets/img/gallery/thumbs/efg-1x1-18-12.jpg"></a>
                    </div>


                    <div class="popup-gallery__item col-xs-6 col-md-4">
                        <a href="assets/img/gallery/efg-1x1-18-13.jpg"><img src="assets/img/gallery/thumbs/efg-1x1-18-13.jpg"></a>
                    </div>


                    <div class="popup-gallery__item col-xs-6 col-md-4">
                        <a href="assets/img/gallery/efg-1x1-18-14.jpg"><img src="assets/img/gallery/thumbs/efg-1x1-18-14.jpg"></a>
                    </div>


                    <div class="popup-gallery__item col-xs-6 col-md-4">
                        <a href="assets/img/gallery/efg-1x1-18-15.jpg"><img src="assets/img/gallery/thumbs/efg-1x1-18-15.jpg"></a>
                    </div>


                    <div class="popup-gallery__item col-xs-6 col-md-4">
                        <a href="assets/img/gallery/efg-1x1-18-16.jpg"><img src="assets/img/gallery/thumbs/efg-1x1-18-16.jpg"></a>
                    </div>


                    <div class="popup-gallery__item col-xs-6 col-md-4">
                        <a href="assets/img/gallery/efg-1x1-18-17.jpg"><img src="assets/img/gallery/thumbs/efg-1x1-18-17.jpg"></a>
                    </div>


                    <div class="popup-gallery__item col-xs-6 col-md-4">
                        <a href="assets/img/gallery/efg-1x1-18-18.jpg"><img src="assets/img/gallery/thumbs/efg-1x1-18-18.jpg"></a>
                    </div>


                    <div class="popup-gallery__item col-xs-6 col-md-4">
                        <a href="assets/img/gallery/efg-1x1-18-19.jpg"><img src="assets/img/gallery/thumbs/efg-1x1-18-19.jpg"></a>
                    </div>


                    <div class="popup-gallery__item col-xs-6 col-md-4">
                        <a href="assets/img/gallery/efg-1x1-18-20.jpg"><img src="assets/img/gallery/thumbs/efg-1x1-18-20.jpg"></a>
                    </div>


                    <div class="popup-gallery__item col-xs-6 col-md-4">
                        <a href="assets/img/gallery/efg-1x1-18-21.jpg"><img src="assets/img/gallery/thumbs/efg-1x1-18-21.jpg"></a>
                    </div>


                    <div class="popup-gallery__item col-xs-6 col-md-4">
                        <a href="assets/img/gallery/efg-1x1-18-22.jpg"><img src="assets/img/gallery/thumbs/efg-1x1-18-22.jpg"></a>
                    </div>


                    <div class="popup-gallery__item col-xs-6 col-md-4">
                        <a href="assets/img/gallery/efg-1x1-18-23.jpg"><img src="assets/img/gallery/thumbs/efg-1x1-18-23.jpg"></a>
                    </div>


                    <div class="popup-gallery__item col-xs-6 col-md-4">
                        <a href="assets/img/gallery/efg-1x1-18-24.jpg"><img src="assets/img/gallery/thumbs/efg-1x1-18-24.jpg"></a>
                    </div>


                    <div class="popup-gallery__item col-xs-6 col-md-4">
                        <a href="assets/img/gallery/efg-1x1-18-25.jpg"><img src="assets/img/gallery/thumbs/efg-1x1-18-25.jpg"></a>
                    </div>


                    <div class="popup-gallery__item col-xs-6 col-md-4">
                        <a href="assets/img/gallery/efg-1x1-18-26.jpg"><img src="assets/img/gallery/thumbs/efg-1x1-18-26.jpg"></a>
                    </div>


                    <div class="popup-gallery__item col-xs-6 col-md-4">
                        <a href="assets/img/gallery/efg-1x1-18-27.jpg"><img src="assets/img/gallery/thumbs/efg-1x1-18-27.jpg"></a>
                    </div>


                    <div class="popup-gallery__item col-xs-6 col-md-4">
                        <a href="assets/img/gallery/efg-1x1-18-28.jpg"><img src="assets/img/gallery/thumbs/efg-1x1-18-28.jpg"></a>
                    </div>


                    <div class="popup-gallery__item col-xs-6 col-md-4">
                        <a href="assets/img/gallery/efg-1x1-18-29.jpg"><img src="assets/img/gallery/thumbs/efg-1x1-18-29.jpg"></a>
                    </div>


                    <div class="popup-gallery__item col-xs-6 col-md-4">
                        <a href="assets/img/gallery/efg-1x1-18-30.jpg"><img src="assets/img/gallery/thumbs/efg-1x1-18-30.jpg"></a>
                    </div>


                    <div class="popup-gallery__item col-xs-6 col-md-4">
                        <a href="assets/img/gallery/efg-1x1-18-31.jpg"><img src="assets/img/gallery/thumbs/efg-1x1-18-31.jpg"></a>
                    </div>


                    <div class="popup-gallery__item col-xs-6 col-md-4">
                        <a href="assets/img/gallery/efg-1x1-18-32.jpg"><img src="assets/img/gallery/thumbs/efg-1x1-18-32.jpg"></a>
                    </div>


                    <div class="popup-gallery__item col-xs-6 col-md-4">
                        <a href="assets/img/gallery/efg-1x1-18-33.jpg"><img src="assets/img/gallery/thumbs/efg-1x1-18-33.jpg"></a>
                    </div>


                    <div class="popup-gallery__item col-xs-6 col-md-4">
                        <a href="assets/img/gallery/efg-1x1-18-34.jpg"><img src="assets/img/gallery/thumbs/efg-1x1-18-34.jpg"></a>
                    </div>


                    <div class="popup-gallery__item col-xs-6 col-md-4">
                        <a href="assets/img/gallery/efg-1x1-18-35.jpg"><img src="assets/img/gallery/thumbs/efg-1x1-18-35.jpg"></a>
                    </div>


                    <div class="popup-gallery__item col-xs-6 col-md-4">
                        <a href="assets/img/gallery/efg-1x1-18-36.jpg"><img src="assets/img/gallery/thumbs/efg-1x1-18-36.jpg"></a>
                    </div>


                    <div class="popup-gallery__item col-xs-6 col-md-4">
                        <a href="assets/img/gallery/efg-1x1-18-37.jpg"><img src="assets/img/gallery/thumbs/efg-1x1-18-37.jpg"></a>
                    </div>


                    <div class="popup-gallery__item col-xs-6 col-md-4">
                        <a href="assets/img/gallery/efg-1x1-18-38.jpg"><img src="assets/img/gallery/thumbs/efg-1x1-18-38.jpg"></a>
                    </div>


                    <div class="popup-gallery__item col-xs-6 col-md-4">
                        <a href="assets/img/gallery/efg-1x1-18-39.jpg"><img src="assets/img/gallery/thumbs/efg-1x1-18-39.jpg"></a>
                    </div>


                    <div class="popup-gallery__item col-xs-6 col-md-4">
                        <a href="assets/img/gallery/efg-1x1-18-40.jpg"><img src="assets/img/gallery/thumbs/efg-1x1-18-40.jpg"></a>
                    </div>


                    <div class="popup-gallery__item col-xs-6 col-md-4">
                        <a href="assets/img/gallery/efg-1x1-18-41.jpg"><img src="assets/img/gallery/thumbs/efg-1x1-18-41.jpg"></a>
                    </div>


                    <div class="popup-gallery__item col-xs-6 col-md-4">
                        <a href="assets/img/gallery/efg-1x1-18-42.jpg"><img src="assets/img/gallery/thumbs/efg-1x1-18-42.jpg"></a>
                    </div>


                    <div class="popup-gallery__item col-xs-6 col-md-4">
                        <a href="assets/img/gallery/efg-1x1-18-43.jpg"><img src="assets/img/gallery/thumbs/efg-1x1-18-43.jpg"></a>
                    </div>


                    <div class="popup-gallery__item col-xs-6 col-md-4">
                        <a href="assets/img/gallery/efg-1x1-18-44.jpg"><img src="assets/img/gallery/thumbs/efg-1x1-18-44.jpg"></a>
                    </div>


                    <div class="popup-gallery__item col-xs-6 col-md-4">
                        <a href="assets/img/gallery/efg-1x1-18-45.jpg"><img src="assets/img/gallery/thumbs/efg-1x1-18-45.jpg"></a>
                    </div>


                    <div class="popup-gallery__item col-xs-6 col-md-4">
                        <a href="assets/img/gallery/efg-1x1-18-46.jpg"><img src="assets/img/gallery/thumbs/efg-1x1-18-46.jpg"></a>
                    </div>


                    <div class="popup-gallery__item col-xs-6 col-md-4">
                        <a href="assets/img/gallery/efg-1x1-18-47.jpg"><img src="assets/img/gallery/thumbs/efg-1x1-18-47.jpg"></a>
                    </div>


                    <div class="popup-gallery__item col-xs-6 col-md-4">
                        <a href="assets/img/gallery/efg-1x1-18-48.jpg"><img src="assets/img/gallery/thumbs/efg-1x1-18-48.jpg"></a>
                    </div>


                    <div class="popup-gallery__item col-xs-6 col-md-4">
                        <a href="assets/img/gallery/efg-1x1-18-49.jpg"><img src="assets/img/gallery/thumbs/efg-1x1-18-49.jpg"></a>
                    </div>


                    <div class="popup-gallery__item col-xs-6 col-md-4">
                        <a href="assets/img/gallery/efg-1x1-18-50.jpg"><img src="assets/img/gallery/thumbs/efg-1x1-18-50.jpg"></a>
                    </div>


                    <div class="popup-gallery__item col-xs-6 col-md-4">
                        <a href="assets/img/gallery/efg-1x1-18-51.jpg"><img src="assets/img/gallery/thumbs/efg-1x1-18-51.jpg"></a>
                    </div>


                    <div class="popup-gallery__item col-xs-6 col-md-4">
                        <a href="assets/img/gallery/efg-1x1-18-52.jpg"><img src="assets/img/gallery/thumbs/efg-1x1-18-52.jpg"></a>
                    </div>


                    <div class="popup-gallery__item col-xs-6 col-md-4">
                        <a href="assets/img/gallery/efg-1x1-18-53.jpg"><img src="assets/img/gallery/thumbs/efg-1x1-18-53.jpg"></a>
                    </div>


                    <div class="popup-gallery__item col-xs-6 col-md-4">
                        <a href="assets/img/gallery/efg-1x1-18-54.jpg"><img src="assets/img/gallery/thumbs/efg-1x1-18-54.jpg"></a>
                    </div>


                    <div class="popup-gallery__item col-xs-6 col-md-4">
                        <a href="assets/img/gallery/efg-1x1-18-55.jpg"><img src="assets/img/gallery/thumbs/efg-1x1-18-55.jpg"></a>
                    </div>


                    <div class="popup-gallery__item col-xs-6 col-md-4">
                        <a href="assets/img/gallery/efg-1x1-18-56.jpg"><img src="assets/img/gallery/thumbs/efg-1x1-18-56.jpg"></a>
                    </div>


                    <div class="popup-gallery__item col-xs-6 col-md-4">
                        <a href="assets/img/gallery/efg-1x1-18-57.jpg"><img src="assets/img/gallery/thumbs/efg-1x1-18-57.jpg"></a>
                    </div>


                    <div class="popup-gallery__item col-xs-6 col-md-4">
                        <a href="assets/img/gallery/efg-1x1-18-58.jpg"><img src="assets/img/gallery/thumbs/efg-1x1-18-58.jpg"></a>
                    </div>


                    <div class="popup-gallery__item col-xs-6 col-md-4">
                        <a href="assets/img/gallery/efg-1x1-18-59.jpg"><img src="assets/img/gallery/thumbs/efg-1x1-18-59.jpg"></a>
                    </div>


                    <div class="popup-gallery__item col-xs-6 col-md-4">
                        <a href="assets/img/gallery/efg-1x1-18-60.jpg"><img src="assets/img/gallery/thumbs/efg-1x1-18-60.jpg"></a>
                    </div>


                    <div class="popup-gallery__item col-xs-6 col-md-4">
                        <a href="assets/img/gallery/efg-1x1-18-61.jpg"><img src="assets/img/gallery/thumbs/efg-1x1-18-61.jpg"></a>
                    </div>


                    <div class="popup-gallery__item col-xs-6 col-md-4">
                        <a href="assets/img/gallery/efg-1x1-18-62.jpg"><img src="assets/img/gallery/thumbs/efg-1x1-18-62.jpg"></a>
                    </div>


                    <div class="popup-gallery__item col-xs-6 col-md-4">
                        <a href="assets/img/gallery/efg-1x1-18-63.jpg"><img src="assets/img/gallery/thumbs/efg-1x1-18-63.jpg"></a>
                    </div>


                    <div class="popup-gallery__item col-xs-6 col-md-4">
                        <a href="assets/img/gallery/efg-1x1-18-64.jpg"><img src="assets/img/gallery/thumbs/efg-1x1-18-64.jpg"></a>
                    </div>


                    <div class="popup-gallery__item col-xs-6 col-md-4">
                        <a href="assets/img/gallery/efg-1x1-18-65.jpg"><img src="assets/img/gallery/thumbs/efg-1x1-18-65.jpg"></a>
                    </div>


                    <div class="popup-gallery__item col-xs-6 col-md-4">
                        <a href="assets/img/gallery/efg-1x1-18-66.jpg"><img src="assets/img/gallery/thumbs/efg-1x1-18-66.jpg"></a>
                    </div>


                    <div class="popup-gallery__item col-xs-6 col-md-4">
                        <a href="assets/img/gallery/efg-1x1-18-67.jpg"><img src="assets/img/gallery/thumbs/efg-1x1-18-67.jpg"></a>
                    </div>


                    <div class="popup-gallery__item col-xs-6 col-md-4">
                        <a href="assets/img/gallery/efg-1x1-18-68.jpg"><img src="assets/img/gallery/thumbs/efg-1x1-18-68.jpg"></a>
                    </div>


                    <div class="popup-gallery__item col-xs-6 col-md-4">
                        <a href="assets/img/gallery/efg-1x1-18-69.jpg"><img src="assets/img/gallery/thumbs/efg-1x1-18-69.jpg"></a>
                    </div>


                    <div class="popup-gallery__item col-xs-6 col-md-4">
                        <a href="assets/img/gallery/efg-1x1-18-70.jpg"><img src="assets/img/gallery/thumbs/efg-1x1-18-70.jpg"></a>
                    </div>


                    <div class="popup-gallery__item col-xs-6 col-md-4">
                        <a href="assets/img/gallery/efg-1x1-18-71.jpg"><img src="assets/img/gallery/thumbs/efg-1x1-18-71.jpg"></a>
                    </div>


                    <div class="popup-gallery__item col-xs-6 col-md-4">
                        <a href="assets/img/gallery/efg-1x1-18-72.jpg"><img src="assets/img/gallery/thumbs/efg-1x1-18-72.jpg"></a>
                    </div>


                    <div class="popup-gallery__item col-xs-6 col-md-4">
                        <a href="assets/img/gallery/efg-1x1-18-73.jpg"><img src="assets/img/gallery/thumbs/efg-1x1-18-73.jpg"></a>
                    </div>


                    <div class="popup-gallery__item col-xs-6 col-md-4">
                        <a href="assets/img/gallery/efg-1x1-18-74.jpg"><img src="assets/img/gallery/thumbs/efg-1x1-18-74.jpg"></a>
                    </div>


                    <div class="popup-gallery__item col-xs-6 col-md-4">
                        <a href="assets/img/gallery/efg-1x1-18-75.jpg"><img src="assets/img/gallery/thumbs/efg-1x1-18-75.jpg"></a>
                    </div>


                    <div class="popup-gallery__item col-xs-6 col-md-4">
                        <a href="assets/img/gallery/efg-1x1-18-76.jpg"><img src="assets/img/gallery/thumbs/efg-1x1-18-76.jpg"></a>
                    </div>


                    <div class="popup-gallery__item col-xs-6 col-md-4">
                        <a href="assets/img/gallery/efg-1x1-18-77.jpg"><img src="assets/img/gallery/thumbs/efg-1x1-18-77.jpg"></a>
                    </div>


                    <div class="popup-gallery__item col-xs-6 col-md-4">
                        <a href="assets/img/gallery/efg-1x1-18-78.jpg"><img src="assets/img/gallery/thumbs/efg-1x1-18-78.jpg"></a>
                    </div>


                    <div class="popup-gallery__item col-xs-6 col-md-4">
                        <a href="assets/img/gallery/efg-1x1-18-79.jpg"><img src="assets/img/gallery/thumbs/efg-1x1-18-79.jpg"></a>
                    </div>


                    <div class="popup-gallery__item col-xs-6 col-md-4">
                        <a href="assets/img/gallery/efg-1x1-18-80.jpg"><img src="assets/img/gallery/thumbs/efg-1x1-18-80.jpg"></a>
                    </div>


                    <div class="popup-gallery__item col-xs-6 col-md-4">
                        <a href="assets/img/gallery/efg-1x1-18-81.jpg"><img src="assets/img/gallery/thumbs/efg-1x1-18-81.jpg"></a>
                    </div>


                    <div class="popup-gallery__item col-xs-6 col-md-4">
                        <a href="assets/img/gallery/efg-1x1-18-82.jpg"><img src="assets/img/gallery/thumbs/efg-1x1-18-82.jpg"></a>
                    </div>


                    <div class="popup-gallery__item col-xs-6 col-md-4">
                        <a href="assets/img/gallery/efg-1x1-18-83.jpg"><img src="assets/img/gallery/thumbs/efg-1x1-18-83.jpg"></a>
                    </div>


                    <div class="popup-gallery__item col-xs-6 col-md-4">
                        <a href="assets/img/gallery/efg-1x1-18-84.jpg"><img src="assets/img/gallery/thumbs/efg-1x1-18-84.jpg"></a>
                    </div>


                    <div class="popup-gallery__item col-xs-6 col-md-4">
                        <a href="assets/img/gallery/efg-1x1-18-85.jpg"><img src="assets/img/gallery/thumbs/efg-1x1-18-85.jpg"></a>
                    </div>


                    <div class="popup-gallery__item col-xs-6 col-md-4">
                        <a href="assets/img/gallery/efg-1x1-18-86.jpg"><img src="assets/img/gallery/thumbs/efg-1x1-18-86.jpg"></a>
                    </div>


                    <div class="popup-gallery__item col-xs-6 col-md-4">
                        <a href="assets/img/gallery/efg-1x1-18-87.jpg"><img src="assets/img/gallery/thumbs/efg-1x1-18-87.jpg"></a>
                    </div>


                    <div class="popup-gallery__item col-xs-6 col-md-4">
                        <a href="assets/img/gallery/efg-1x1-18-88.jpg"><img src="assets/img/gallery/thumbs/efg-1x1-18-88.jpg"></a>
                    </div>


                    <div class="popup-gallery__item col-xs-6 col-md-4">
                        <a href="assets/img/gallery/efg-1x1-18-89.jpg"><img src="assets/img/gallery/thumbs/efg-1x1-18-89.jpg"></a>
                    </div>


                    <div class="popup-gallery__item col-xs-6 col-md-4">
                        <a href="assets/img/gallery/efg-1x1-18-90.jpg"><img src="assets/img/gallery/thumbs/efg-1x1-18-90.jpg"></a>
                    </div>


                    <div class="popup-gallery__item col-xs-6 col-md-4">
                        <a href="assets/img/gallery/efg-1x1-18-91.jpg"><img src="assets/img/gallery/thumbs/efg-1x1-18-91.jpg"></a>
                    </div>


                    <div class="popup-gallery__item col-xs-6 col-md-4">
                        <a href="assets/img/gallery/efg-1x1-18-92.jpg"><img src="assets/img/gallery/thumbs/efg-1x1-18-92.jpg"></a>
                    </div>


                    <div class="popup-gallery__item col-xs-6 col-md-4">
                        <a href="assets/img/gallery/efg-1x1-18-93.jpg"><img src="assets/img/gallery/thumbs/efg-1x1-18-93.jpg"></a>
                    </div>


                    <div class="popup-gallery__item col-xs-6 col-md-4">
                        <a href="assets/img/gallery/efg-1x1-18-94.jpg"><img src="assets/img/gallery/thumbs/efg-1x1-18-94.jpg"></a>
                    </div>


                    <div class="popup-gallery__item col-xs-6 col-md-4">
                        <a href="assets/img/gallery/efg-1x1-18-95.jpg"><img src="assets/img/gallery/thumbs/efg-1x1-18-95.jpg"></a>
                    </div>


                    <div class="popup-gallery__item col-xs-6 col-md-4">
                        <a href="assets/img/gallery/efg-1x1-18-96.jpg"><img src="assets/img/gallery/thumbs/efg-1x1-18-96.jpg"></a>
                    </div>


                    <div class="popup-gallery__item col-xs-6 col-md-4">
                        <a href="assets/img/gallery/efg-1x1-18-97.jpg"><img src="assets/img/gallery/thumbs/efg-1x1-18-97.jpg"></a>
                    </div>


                    <div class="popup-gallery__item col-xs-6 col-md-4">
                        <a href="assets/img/gallery/efg-1x1-18-98.jpg"><img src="assets/img/gallery/thumbs/efg-1x1-18-98.jpg"></a>
                    </div>


                    <div class="popup-gallery__item col-xs-6 col-md-4">
                        <a href="assets/img/gallery/efg-1x1-18-99.jpg"><img src="assets/img/gallery/thumbs/efg-1x1-18-99.jpg"></a>
                    </div>


                    <div class="popup-gallery__item col-xs-6 col-md-4">
                        <a href="assets/img/gallery/efg-1x1-18-100.jpg"><img src="assets/img/gallery/thumbs/efg-1x1-18-100.jpg"></a>
                    </div>


                    <div class="popup-gallery__item col-xs-6 col-md-4">
                        <a href="assets/img/gallery/efg-1x1-18-101.jpg"><img src="assets/img/gallery/thumbs/efg-1x1-18-101.jpg"></a>
                    </div>


                    <div class="popup-gallery__item col-xs-6 col-md-4">
                        <a href="assets/img/gallery/efg-1x1-18-102.jpg"><img src="assets/img/gallery/thumbs/efg-1x1-18-102.jpg"></a>
                    </div>


                    <div class="popup-gallery__item col-xs-6 col-md-4">
                        <a href="assets/img/gallery/efg-1x1-18-103.jpg"><img src="assets/img/gallery/thumbs/efg-1x1-18-103.jpg"></a>
                    </div>


                    <div class="popup-gallery__item col-xs-6 col-md-4">
                        <a href="assets/img/gallery/efg-1x1-18-104.jpg"><img src="assets/img/gallery/thumbs/efg-1x1-18-104.jpg"></a>
                    </div>


                    <div class="popup-gallery__item col-xs-6 col-md-4">
                        <a href="assets/img/gallery/efg-1x1-18-105.jpg"><img src="assets/img/gallery/thumbs/efg-1x1-18-105.jpg"></a>
                    </div>


                    <div class="popup-gallery__item col-xs-6 col-md-4">
                        <a href="assets/img/gallery/efg-1x1-18-106.jpg"><img src="assets/img/gallery/thumbs/efg-1x1-18-106.jpg"></a>
                    </div>


                    <div class="popup-gallery__item col-xs-6 col-md-4">
                        <a href="assets/img/gallery/efg-1x1-18-107.jpg"><img src="assets/img/gallery/thumbs/efg-1x1-18-107.jpg"></a>
                    </div>


                    <div class="popup-gallery__item col-xs-6 col-md-4">
                        <a href="assets/img/gallery/efg-1x1-18-108.jpg"><img src="assets/img/gallery/thumbs/efg-1x1-18-108.jpg"></a>
                    </div>


                    <div class="popup-gallery__item col-xs-6 col-md-4">
                        <a href="assets/img/gallery/efg-1x1-18-109.jpg"><img src="assets/img/gallery/thumbs/efg-1x1-18-109.jpg"></a>
                    </div>


                    <div class="popup-gallery__item col-xs-6 col-md-4">
                        <a href="assets/img/gallery/efg-1x1-18-110.jpg"><img src="assets/img/gallery/thumbs/efg-1x1-18-110.jpg"></a>
                    </div>


                    <div class="popup-gallery__item col-xs-6 col-md-4">
                        <a href="assets/img/gallery/efg-1x1-18-111.jpg"><img src="assets/img/gallery/thumbs/efg-1x1-18-111.jpg"></a>
                    </div>


                    <div class="popup-gallery__item col-xs-6 col-md-4">
                        <a href="assets/img/gallery/efg-1x1-18-112.jpg"><img src="assets/img/gallery/thumbs/efg-1x1-18-112.jpg"></a>
                    </div>


                    <div class="popup-gallery__item col-xs-6 col-md-4">
                        <a href="assets/img/gallery/efg-1x1-18-113.jpg"><img src="assets/img/gallery/thumbs/efg-1x1-18-113.jpg"></a>
                    </div>


                    <div class="popup-gallery__item col-xs-6 col-md-4">
                        <a href="assets/img/gallery/efg-1x1-18-114.jpg"><img src="assets/img/gallery/thumbs/efg-1x1-18-114.jpg"></a>
                    </div>


                    <div class="popup-gallery__item col-xs-6 col-md-4">
                        <a href="assets/img/gallery/efg-1x1-18-115.jpg"><img src="assets/img/gallery/thumbs/efg-1x1-18-115.jpg"></a>
                    </div>


                    <div class="popup-gallery__item col-xs-6 col-md-4">
                        <a href="assets/img/gallery/efg-1x1-18-116.jpg"><img src="assets/img/gallery/thumbs/efg-1x1-18-116.jpg"></a>
                    </div>


                    <div class="popup-gallery__item col-xs-6 col-md-4">
                        <a href="assets/img/gallery/efg-1x1-18-117.jpg"><img src="assets/img/gallery/thumbs/efg-1x1-18-117.jpg"></a>
                    </div>


                    <div class="popup-gallery__item col-xs-6 col-md-4">
                        <a href="assets/img/gallery/efg-1x1-18-118.jpg"><img src="assets/img/gallery/thumbs/efg-1x1-18-118.jpg"></a>
                    </div>


                    <div class="popup-gallery__item col-xs-6 col-md-4">
                        <a href="assets/img/gallery/efg-1x1-18-119.jpg"><img src="assets/img/gallery/thumbs/efg-1x1-18-119.jpg"></a>
                    </div>


                    <div class="popup-gallery__item col-xs-6 col-md-4">
                        <a href="assets/img/gallery/efg-1x1-18-120.jpg"><img src="assets/img/gallery/thumbs/efg-1x1-18-120.jpg"></a>
                    </div>


                    <div class="popup-gallery__item col-xs-6 col-md-4">
                        <a href="assets/img/gallery/efg-1x1-18-121.jpg"><img src="assets/img/gallery/thumbs/efg-1x1-18-121.jpg"></a>
                    </div>


                    <div class="popup-gallery__item col-xs-6 col-md-4">
                        <a href="assets/img/gallery/efg-1x1-18-122.jpg"><img src="assets/img/gallery/thumbs/efg-1x1-18-122.jpg"></a>
                    </div>


                    <div class="popup-gallery__item col-xs-6 col-md-4">
                        <a href="assets/img/gallery/efg-1x1-18-123.jpg"><img src="assets/img/gallery/thumbs/efg-1x1-18-123.jpg"></a>
                    </div>


                    <div class="popup-gallery__item col-xs-6 col-md-4">
                        <a href="assets/img/gallery/efg-1x1-18-124.jpg"><img src="assets/img/gallery/thumbs/efg-1x1-18-124.jpg"></a>
                    </div>


                    <div class="popup-gallery__item col-xs-6 col-md-4">
                        <a href="assets/img/gallery/efg-1x1-18-125.jpg"><img src="assets/img/gallery/thumbs/efg-1x1-18-125.jpg"></a>
                    </div>


                    <div class="popup-gallery__item col-xs-6 col-md-4">
                        <a href="assets/img/gallery/efg-1x1-18-126.jpg"><img src="assets/img/gallery/thumbs/efg-1x1-18-126.jpg"></a>
                    </div>


                    <div class="popup-gallery__item col-xs-6 col-md-4">
                        <a href="assets/img/gallery/efg-1x1-18-127.jpg"><img src="assets/img/gallery/thumbs/efg-1x1-18-127.jpg"></a>
                    </div>


                    <div class="popup-gallery__item col-xs-6 col-md-4">
                        <a href="assets/img/gallery/efg-1x1-18-128.jpg"><img src="assets/img/gallery/thumbs/efg-1x1-18-128.jpg"></a>
                    </div>


                    <div class="popup-gallery__item col-xs-6 col-md-4">
                        <a href="assets/img/gallery/efg-1x1-18-129.jpg"><img src="assets/img/gallery/thumbs/efg-1x1-18-129.jpg"></a>
                    </div>


                    <div class="popup-gallery__item col-xs-6 col-md-4">
                        <a href="assets/img/gallery/efg-1x1-18-130.jpg"><img src="assets/img/gallery/thumbs/efg-1x1-18-130.jpg"></a>
                    </div>


                    <div class="popup-gallery__item col-xs-6 col-md-4">
                        <a href="assets/img/gallery/efg-1x1-18-131.jpg"><img src="assets/img/gallery/thumbs/efg-1x1-18-131.jpg"></a>
                    </div>


                    <div class="popup-gallery__item col-xs-6 col-md-4">
                        <a href="assets/img/gallery/efg-1x1-18-132.jpg"><img src="assets/img/gallery/thumbs/efg-1x1-18-132.jpg"></a>
                    </div>


                    <div class="popup-gallery__item col-xs-6 col-md-4">
                        <a href="assets/img/gallery/efg-1x1-18-133.jpg"><img src="assets/img/gallery/thumbs/efg-1x1-18-133.jpg"></a>
                    </div>


                    <div class="popup-gallery__item col-xs-6 col-md-4">
                        <a href="assets/img/gallery/efg-1x1-18-134.jpg"><img src="assets/img/gallery/thumbs/efg-1x1-18-134.jpg"></a>
                    </div>


                    <div class="popup-gallery__item col-xs-6 col-md-4">
                        <a href="assets/img/gallery/efg-1x1-18-135.jpg"><img src="assets/img/gallery/thumbs/efg-1x1-18-135.jpg"></a>
                    </div>


                    <div class="popup-gallery__item col-xs-6 col-md-4">
                        <a href="assets/img/gallery/efg-1x1-18-136.jpg"><img src="assets/img/gallery/thumbs/efg-1x1-18-136.jpg"></a>
                    </div>


                    <div class="popup-gallery__item col-xs-6 col-md-4">
                        <a href="assets/img/gallery/efg-1x1-18-137.jpg"><img src="assets/img/gallery/thumbs/efg-1x1-18-137.jpg"></a>
                    </div>


                    <div class="popup-gallery__item col-xs-6 col-md-4">
                        <a href="assets/img/gallery/efg-1x1-18-138.jpg"><img src="assets/img/gallery/thumbs/efg-1x1-18-138.jpg"></a>
                    </div>


                    <div class="popup-gallery__item col-xs-6 col-md-4">
                        <a href="assets/img/gallery/efg-1x1-18-139.jpg"><img src="assets/img/gallery/thumbs/efg-1x1-18-139.jpg"></a>
                    </div>


                    <div class="popup-gallery__item col-xs-6 col-md-4">
                        <a href="assets/img/gallery/efg-1x1-18-140.jpg"><img src="assets/img/gallery/thumbs/efg-1x1-18-140.jpg"></a>
                    </div>


                    <div class="popup-gallery__item col-xs-6 col-md-4">
                        <a href="assets/img/gallery/efg-1x1-18-141.jpg"><img src="assets/img/gallery/thumbs/efg-1x1-18-141.jpg"></a>
                    </div>


                    <div class="popup-gallery__item col-xs-6 col-md-4">
                        <a href="assets/img/gallery/efg-1x1-18-142.jpg"><img src="assets/img/gallery/thumbs/efg-1x1-18-142.jpg"></a>
                    </div>


                    <div class="popup-gallery__item col-xs-6 col-md-4">
                        <a href="assets/img/gallery/efg-1x1-18-143.jpg"><img src="assets/img/gallery/thumbs/efg-1x1-18-143.jpg"></a>
                    </div>


                    <div class="popup-gallery__item col-xs-6 col-md-4">
                        <a href="assets/img/gallery/efg-1x1-18-144.jpg"><img src="assets/img/gallery/thumbs/efg-1x1-18-144.jpg"></a>
                    </div>


                    <div class="popup-gallery__item col-xs-6 col-md-4">
                        <a href="assets/img/gallery/efg-1x1-18-145.jpg"><img src="assets/img/gallery/thumbs/efg-1x1-18-145.jpg"></a>
                    </div>


                    <div class="popup-gallery__item col-xs-6 col-md-4">
                        <a href="assets/img/gallery/efg-1x1-18-146.jpg"><img src="assets/img/gallery/thumbs/efg-1x1-18-146.jpg"></a>
                    </div>


                    <div class="popup-gallery__item col-xs-6 col-md-4">
                        <a href="assets/img/gallery/efg-1x1-18-147.jpg"><img src="assets/img/gallery/thumbs/efg-1x1-18-147.jpg"></a>
                    </div>


                    <div class="popup-gallery__item col-xs-6 col-md-4">
                        <a href="assets/img/gallery/efg-1x1-18-148.jpg"><img src="assets/img/gallery/thumbs/efg-1x1-18-148.jpg"></a>
                    </div>


                    <div class="popup-gallery__item col-xs-6 col-md-4">
                        <a href="assets/img/gallery/efg-1x1-18-149.jpg"><img src="assets/img/gallery/thumbs/efg-1x1-18-149.jpg"></a>
                    </div>


                    <div class="popup-gallery__item col-xs-6 col-md-4">
                        <a href="assets/img/gallery/efg-1x1-18-150.jpg"><img src="assets/img/gallery/thumbs/efg-1x1-18-150.jpg"></a>
                    </div>


                    <div class="popup-gallery__item col-xs-6 col-md-4">
                        <a href="assets/img/gallery/efg-1x1-18-151.jpg"><img src="assets/img/gallery/thumbs/efg-1x1-18-151.jpg"></a>
                    </div>


                    <div class="popup-gallery__item col-xs-6 col-md-4">
                        <a href="assets/img/gallery/efg-1x1-18-152.jpg"><img src="assets/img/gallery/thumbs/efg-1x1-18-152.jpg"></a>
                    </div>


                    <div class="popup-gallery__item col-xs-6 col-md-4">
                        <a href="assets/img/gallery/efg-1x1-18-153.jpg"><img src="assets/img/gallery/thumbs/efg-1x1-18-153.jpg"></a>
                    </div>


                    <div class="popup-gallery__item col-xs-6 col-md-4">
                        <a href="assets/img/gallery/efg-1x1-18-154.jpg"><img src="assets/img/gallery/thumbs/efg-1x1-18-154.jpg"></a>
                    </div>


                    <div class="popup-gallery__item col-xs-6 col-md-4">
                        <a href="assets/img/gallery/efg-1x1-18-155.jpg"><img src="assets/img/gallery/thumbs/efg-1x1-18-155.jpg"></a>
                    </div>


                    <div class="popup-gallery__item col-xs-6 col-md-4">
                        <a href="assets/img/gallery/efg-1x1-18-156.jpg"><img src="assets/img/gallery/thumbs/efg-1x1-18-156.jpg"></a>
                    </div>


                    <div class="popup-gallery__item col-xs-6 col-md-4">
                        <a href="assets/img/gallery/efg-1x1-18-157.jpg"><img src="assets/img/gallery/thumbs/efg-1x1-18-157.jpg"></a>
                    </div>


                    <div class="popup-gallery__item col-xs-6 col-md-4">
                        <a href="assets/img/gallery/efg-1x1-18-158.jpg"><img src="assets/img/gallery/thumbs/efg-1x1-18-158.jpg"></a>
                    </div>


                    <div class="popup-gallery__item col-xs-6 col-md-4">
                        <a href="assets/img/gallery/efg-1x1-18-159.jpg"><img src="assets/img/gallery/thumbs/efg-1x1-18-159.jpg"></a>
                    </div>


                    <div class="popup-gallery__item col-xs-6 col-md-4">
                        <a href="assets/img/gallery/efg-1x1-18-160.jpg"><img src="assets/img/gallery/thumbs/efg-1x1-18-160.jpg"></a>
                    </div>


                    <div class="popup-gallery__item col-xs-6 col-md-4">
                        <a href="assets/img/gallery/efg-1x1-18-161.jpg"><img src="assets/img/gallery/thumbs/efg-1x1-18-161.jpg"></a>
                    </div>


                    <div class="popup-gallery__item col-xs-6 col-md-4">
                        <a href="assets/img/gallery/efg-1x1-18-162.jpg"><img src="assets/img/gallery/thumbs/efg-1x1-18-162.jpg"></a>
                    </div>


                    <div class="popup-gallery__item col-xs-6 col-md-4">
                        <a href="assets/img/gallery/efg-1x1-18-163.jpg"><img src="assets/img/gallery/thumbs/efg-1x1-18-163.jpg"></a>
                    </div>


                    <div class="popup-gallery__item col-xs-6 col-md-4">
                        <a href="assets/img/gallery/efg-1x1-18-164.jpg"><img src="assets/img/gallery/thumbs/efg-1x1-18-164.jpg"></a>
                    </div>


                    <div class="popup-gallery__item col-xs-6 col-md-4">
                        <a href="assets/img/gallery/efg-1x1-18-165.jpg"><img src="assets/img/gallery/thumbs/efg-1x1-18-165.jpg"></a>
                    </div>


                    <div class="popup-gallery__item col-xs-6 col-md-4">
                        <a href="assets/img/gallery/efg-1x1-18-166.jpg"><img src="assets/img/gallery/thumbs/efg-1x1-18-166.jpg"></a>
                    </div>


                    <div class="popup-gallery__item col-xs-6 col-md-4">
                        <a href="assets/img/gallery/efg-1x1-18-167.jpg"><img src="assets/img/gallery/thumbs/efg-1x1-18-167.jpg"></a>
                    </div>


                    <div class="popup-gallery__item col-xs-6 col-md-4">
                        <a href="assets/img/gallery/efg-1x1-18-168.jpg"><img src="assets/img/gallery/thumbs/efg-1x1-18-168.jpg"></a>
                    </div>


                    <div class="popup-gallery__item col-xs-6 col-md-4">
                        <a href="assets/img/gallery/efg-1x1-18-169.jpg"><img src="assets/img/gallery/thumbs/efg-1x1-18-169.jpg"></a>
                    </div>


                    <div class="popup-gallery__item col-xs-6 col-md-4">
                        <a href="assets/img/gallery/efg-1x1-18-170.jpg"><img src="assets/img/gallery/thumbs/efg-1x1-18-170.jpg"></a>
                    </div>


                    <div class="popup-gallery__item col-xs-6 col-md-4">
                        <a href="assets/img/gallery/efg-1x1-18-171.jpg"><img src="assets/img/gallery/thumbs/efg-1x1-18-171.jpg"></a>
                    </div>


                    <div class="popup-gallery__item col-xs-6 col-md-4">
                        <a href="assets/img/gallery/efg-1x1-18-172.jpg"><img src="assets/img/gallery/thumbs/efg-1x1-18-172.jpg"></a>
                    </div>


                    <div class="popup-gallery__item col-xs-6 col-md-4">
                        <a href="assets/img/gallery/efg-1x1-18-173.jpg"><img src="assets/img/gallery/thumbs/efg-1x1-18-173.jpg"></a>
                    </div>


                    <div class="popup-gallery__item col-xs-6 col-md-4">
                        <a href="assets/img/gallery/efg-1x1-18-174.jpg"><img src="assets/img/gallery/thumbs/efg-1x1-18-174.jpg"></a>
                    </div>


                    <div class="popup-gallery__item col-xs-6 col-md-4">
                        <a href="assets/img/gallery/efg-1x1-18-175.jpg"><img src="assets/img/gallery/thumbs/efg-1x1-18-175.jpg"></a>
                    </div>
                </div>
            </div>
        </section>
    </Layout>
</template>

<script>

import Layout from '@/components/layouts/Layout.vue'

export default {
  name: 'Gallery',
  components: {Layout}
};
</script>
